import { ITableField } from '@/shared/Tables/Table'
import { IEquipmentMaintenanceBlank } from '../../../equipment.types.ts'
import timeUtils from '../../../../../utils/time.utils.ts'
import userUtils from '@/pages/User/user.utils.ts'

const equipmentMaintenanceTableFields: ITableField<IEquipmentMaintenanceBlank, keyof IEquipmentMaintenanceBlank>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '180px',
    header: 'Дата обслуживания',
    getter: (it) => timeUtils.formatDate(new Date(it.createdAt), 'dd MMM yyyy HH:mm'),
    sortGetter: (it) => new Date(it.createdAt).getTime(),
  },
  {
    key: 'type',
    clientSideOrdering: true,
    width: '200px',
    header: 'Тип',
    getter: (it) => (it.type === 'PLANNED' ? 'Плановое' : <span className="text-error">Внеплановое</span>),
    sortGetter: (it) => it.comment,
  },
  {
    key: 'comment',
    clientSideOrdering: true,
    width: '400px',
    header: 'Комментарий',
    getter: (it) => it.comment,
    sortGetter: (it) => it.comment,
  },
  {
    key: 'createdBy',
    clientSideOrdering: true,
    width: '200px',
    header: 'Ответственный',
    getter: (it) => userUtils.getFullName(it.createdBy.userInfo),
    sortGetter: (it) => userUtils.getFullName(it.createdBy.userInfo),
  },
]
export default equipmentMaintenanceTableFields
